import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'react-bootstrap';

// Locale
import messages from '../../../locale/messages';

class ListingRules extends Component {
  static propTypes = {
    listingRules: PropTypes.array.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
  };

  render() {
    const { hostDisplayName, listingRules } = this.props;

    return (
      <Panel className="bg-offWhite b-0 p-l">
        <h4 className="mb-s">
          <span>
            {hostDisplayName}
            's <FormattedMessage {...messages.listingRules} />
          </span>
        </h4>
        {listingRules.map(item => (
          <div className="my-t f f-columns f-bc" key={item.id}>
            <span>{item.description}</span>
            <i className={`validCheck t-lx normal fa fa-check-circle validCheck`} />
          </div>
        ))}
      </Panel>
    );
  }
}

export default ListingRules;



// WEBPACK FOOTER //
// ./src/components/Booking/Payment/ListingRules.js